<template>
  <b-nav-item-dropdown id="dropdown-grouped" variant="link" class="dropdown-language" right>
    <template #button-content v-if="currentLocale">
      <b-img :src="`${$root.api_uri}/${currentLocale.img}`" :height="height ?? '14px'" :width="width ?? '22px'" :alt="currentLocale.locale" />
      <span class="d-none d-md-inline ml-50 text-body font-weight-bolder my-0">{{ currentLocale.locale.toUpperCase() }}</span>
    </template>
    <b-dropdown-item v-for="localeObj in locales" :key="localeObj.locale" @click="idiomaElegido(localeObj.locale)">
      <b-img :src="`${$root.api_uri}/${localeObj.img}`" height="14px" width="22px" :alt="localeObj.locale" />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import esImg from '@/assets/images/flags/es.png'
import enImg from '@/assets/images/flags/en.png'
import store from '@/store'
import useAuth from '@core/utils/useAuth';
import { toRefs, ref, computed, toRef, inject,onMounted,onUnmounted } from 'vue'


export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },

  props:{
    height:String|Number,
    width: String | Number,

  },

  setup(props) {
    /* eslint-disable global-require */

    const usuario_id = computed(() => store.state.usuario.usuario.id)
    const { is_loggin } = useAuth();
    const locales = computed(() => store.state.idioma.locales)
    const i18n = inject('i18n')
    const loadLocaleAsync = inject('loadLocaleAsync')
   

    const cargarLocales = () => {
      store.dispatch('idioma/cargarIdiomas')
    } 

    onMounted(() => {
      Echo.channel('idiomas')
      .listen('.IdiomaDeleted',() => cargarLocales())
      .listen('.IdiomaCreated', () => cargarLocales())
      .listen('.IdiomaUpdate', () => cargarLocales())
      .listen('.IdiomaSaved', () => cargarLocales())
    })  


    onUnmounted(() => {
      Echo.leaveChannel('idiomas')
    })


    cargarLocales();
    /* eslint-disable global-require */
    const currentLocale = computed(() => locales.value.find(l => l.locale === i18n.locale));

    const idiomaElegido = (loc) => {
      localStorage.setItem('locale', loc)
      loadLocaleAsync(loc)

      if (is_loggin.value) {
        store.dispatch('usuario/updateLocale', { usuario: usuario_id.value, locale: loc }).then(({ result }) => {
          toast.info('Idioma cambiado con éxito')
        })
      }
    }
    return {
      locales,
      currentLocale,
      idiomaElegido,
    }
  },
}
</script>

<style lang="scss">
.dropdown-language{
  z-index: 6000 !important;
}
</style>
